import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { IResponse } from 'src/app/models/api/response.interface';
import { BehaviorSubject } from 'rxjs';
import { skip, debounceTime, finalize } from 'rxjs/operators';
import { PaginatorComponent } from 'src/app/ui/paginator/paginator.component';
import { Usuario } from 'src/app/models/api/autenticacao/usuario';
import { ApiFuncionarioService } from 'src/app/services/api/autenticacao/api-funcionario.service';
import { ModalService } from 'src/app/ui/modal/modal.service';
import { EmployeePermissionsModalComponent } from './employee-permissions-modal/employee-permissions-modal.component';
import { ToastType } from 'src/app/ui/toast/toast.model';
import { ToastService } from 'src/app/ui/toast/toast.service';

@Component({
  selector: 'c-employee-list',
  templateUrl: './employee-list.component.html',
  styleUrls: ['./employee-list.component.scss']
})
export class EmployeeListComponent implements AfterViewInit {

  @ViewChild('paginator', { static: true }) paginator: PaginatorComponent;

  userData: IResponse<Usuario[]>;
  columns: string[] = ['name', 'email', 'actions'];
  search$ = new BehaviorSubject('');
  sendingPasswordToId: string | null = null;

  constructor(
    private apiFuncionarioService: ApiFuncionarioService,
    private modalService: ModalService,
    private toastService: ToastService
  ) {
    this.configureSearch();
  }

  ngAfterViewInit() {
    this.loadUserData();
  }

  loadUserData() {
    this.apiFuncionarioService.getAll(this.createQueryFilter()).subscribe(res => {
      this.userData = res;
    });
  }

  createQueryFilter() {
    return {
      query: this.search$.value,
      skip: (this.paginator.page - 1) * this.paginator.pageLength,
      take: this.paginator.pageLength
    };
  }

  configureSearch() {
    this.search$.pipe(skip(1), debounceTime(800)).subscribe(() => {
      this.loadUserData();
    });
  }

  async editarPermissoes(funcionarioId: string) {
    const usuario = await this.apiFuncionarioService.getUserByEmployeeId(funcionarioId).toPromise();
    this.modalService.open(EmployeePermissionsModalComponent, {
      initialState: { type: 'dialog' },
      contentInitialState: {
        funcionarioId,
        initialGruposPermissaoIdList: usuario.gruposPermissaoIdList
      }
    });
  }

  redefinePassword(id: string) {
    this.sendingPasswordToId = id;
    this.apiFuncionarioService.redefinePassword(id).pipe(
      finalize(() => this.sendingPasswordToId = null)
    ).subscribe(message => {
      this.toastService.toast(message || 'Senha redefinida com sucesso!', ToastType.success);
    });
  }

}
